import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CatanPinService } from '../services/catan-pin.service';

/**
 * Dodaje igračev PIN i njegov id na Catan zahtjeve.
 *
 * Id nije samo optimizacija: bez njega backend mora redom provjeriti hash svakog
 * igrača. Verify endpoint ga nema (tada se tek saznaje tko je) pa se preskače.
 */
export const catanPinInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api/catan') || req.url.includes('/pin/verify')) {
    return next(req);
  }

  const service = inject(CatanPinService);
  const pin = service.pin();
  const playerId = service.playerId();

  if (!pin || !playerId) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'X-Catan-Pin': pin, 'X-Catan-Player': playerId } }));
};
